<template>
  <div class="loginContainer">
    <img src="./../assets/login/bg.jpg" class="bg" />
    <img src="../assets/login/star.gif" class="starBg" />
    <div class="headerContainer">
      <img src="../assets/login/logo.png" class="topLogo" />
      <!-- <div class="topBtnContainer">
        <div class="topBtn">广告合作</div>
        <div class="topBtn">常见问题</div>
        <div class="topBtn">关于我们</div>
        <div class="topBtn">联系客服</div>
      </div> -->
    </div>
    <div class="footerContainer">
      <div class="centerContainer">
        <div class="qrCodeContainer">
          <img
            src="../assets/85d81507ebe84f210b224bf8e02c6d76966336a7fff89e02e5f088ed492cce1f.png"
            class="qrCode"
          />
        </div>
        <div>
          <p class="qrCodeTitle">手机扫码下载顶端新闻APP</p>
          <p class="linkContainer">
            <span class="linkBtn" @click="jumpFn('https://www.dingxinwen.cn/')"
              >顶端传媒科技（河南）有限公司</span
            >
            丨
            <span
              class="linkBtn"
              @click="jumpFn('https://www.dingxinwen.cn/about')"
              >关于我们</span
            >
            丨
            <span
              class="linkBtn"
              @click="
                jumpFn(
                  'https://activity.dingxinwen.com/creator/static/html/userAgreement.html'
                )
              "
              >用户协议</span
            >
            丨
            <span
              class="linkBtn"
              @click="
                jumpFn(
                  'https://activity.dingxinwen.com/creator/static/html/ddGuide.html'
                )
              "
              >隐私政策</span
            >
            丨
            <span class="linkBtn" @click="jumpFn('https://www.12377.cn/')"
              >网上有害信息举报专区</span
            >
            丨
            <!-- <span class="linkBtn">网络谣言曝光平台</span>丨 -->
            <span
              class="linkBtn"
              @click="jumpFn('https://beian.miit.gov.cn/#/Integrated/index')"
              >豫ICP备2022017130号-3</span
            >
          </p>
        </div>
      </div>
    </div>

    <div class="mainContainer">
      <img src="../assets/login/bigLogo.gif" id="bigLogo" />
      <div class="loginBox">
        <img
          src="../assets/login/codeLogin.png"
          class="loginTypeIcon"
          v-if="loginTypeIndex == 1"
          @click="loginTypeIndex = 0"
        />
        <img
          src="../assets/login/pwdLogin.png"
          class="loginTypeIcon"
          v-else
          @click="loginTypeIndex = 1"
        />
        <div class="oldLogin" v-show="loginTypeIndex == 1">
          <el-tabs v-model="activeName">
            <el-tab-pane label="账号密码登录" name="first">
              <el-input
                placeholder="请输入账号"
                v-model="userAccount"
                clearable
              >
              </el-input>
              <el-input
                placeholder="请输入密码"
                type="password"
                v-model="userPwd"
                clearable
                :show-password="true"
              >
              </el-input>
            </el-tab-pane>
            <el-tab-pane label="短信验证码登录" name="second">
              <el-input
                placeholder="请输入手机号"
                v-model="userTel"
                oninput="value=value.replace(/[^\d]/g,'')"
                clearable
                @keyup.enter.native="login"
                maxlength="11"
              >
              </el-input>
              <div class="inputCodeContainer">
                <el-input
                  placeholder="请输入短信验证码"
                  v-model="telVerification"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  clearable
                  @keyup.enter.native="login"
                  class="regCode"
                  maxlength="6"
                ></el-input>
                <div class="buttonContain">
                  <p class="getRegCodeBtn" @click="codeOpen(1)">
                    {{ regCodeText }}
                  </p>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
          <div class="loginCheckContainer">
            <el-checkbox
              v-model="loginChecked"
              class="loginCheck"
            ></el-checkbox>
            <p class="loginCheckText" @click="loginChecked = !loginChecked">
              我已阅读并同意<span
                class="loginAlert"
                @click.stop="
                  jumpFn(
                    'https://activity.dingxinwen.com/creator/static/html/userAgreement.html'
                  )
                "
                >《用户协议》</span
              >和<span
                class="loginAlert"
                @click.stop="
                  jumpFn(
                    'https://activity.dingxinwen.com/creator/static/html/ddGuide.html'
                  )
                "
                >《隐私政策》</span
              >
            </p>
          </div>
          <p v-if="activeName == 'second'" @click="login()" class="loginBtn">
            登 录
          </p>
          <div class="loginBtnContain" v-if="activeName == 'first'">
            <p class="loginBtn" @click="codeOpen(0)">登 录</p>
          </div>
        </div>
        <div class="codeLogin" v-show="loginTypeIndex == 0">
          <p class="codeTitle">扫码登录</p>
          <div class="qrCodeBorder">
            <div id="qrCode" ref="qrCodeDiv" @click="refreshQrcode"></div>
          </div>
          <p class="qrcodeIntro">打开顶端新闻APP扫描二维码登录</p>
          <div class="refreshQrcode" @click="refreshQrcode">
            <img src="../assets/login/refresh.png" class="refreshIcon" />
            <p class="refreshText">点击刷新</p>
          </div>
        </div>
      </div>
    </div>

    <div id="captcha-element"></div>
    <!--预留的验证码元素，用于配置初始化函数中的element参数-->
    <Button id="buttonAli" class="btn" style="display: none">登录</Button>
    <!--弹出式下，用于触发验证码弹窗的元素-->

    <BanDialog
      ref="banShow"
      :isShow="isBanned"
      @closeBan="isBanned = false"
      :allowClose="true"
    ></BanDialog>
  </div>
</template>

<script>
import { setToken } from "@/utils/libs/auth";
import { USER_HOST, SWUSER_HOST, COMMON_HOST } from "../constants/apiHosts";
import QRCode from "qrcodejs2";
import BanDialog from "../components/banDialog.vue";

export default {
  data() {
    return {
      activeName: "first",
      userTel: "",
      telVerification: "",
      regCodeText: "获取验证码",
      regCodeTime: 60,
      userAccount: "",
      userPwd: "",
      loginT: "",
      loginChecked: false,
      isBanned: false,
      captcha: {},
      loginIndex: 1,
      loginTypeIndex: 0,
    };
  },
  computed: {
    rightTel() {
      var reg = /^1[3456789]\d{9}$/;
      return reg.test(this.userTel);
    },
  },
  components: {
    BanDialog,
  },
  created() {},
  mounted() {
    if (this.$route.query.token) {
      setToken(this.$route.query.token);
      localStorage.setItem("token", this.$route.query.token);

      this.getBan();
    } else {
      this.refreshQrcode();
    }

    let _this = this;
    window.initAliyunCaptcha({
      // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      SceneId: "1cw2vo75",
      // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
      mode: "popup",
      // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      element: "#captcha-element",
      // 触发验证码弹窗或无痕验证的元素
      button: "#buttonAli",
      // 验证码验证通过回调函数
      success: function (captchaVerifyParam) {
        // 入参为验签captchaVerifyParam
        // 1.向后端发起业务请求进行验证码验签captchaVerifyParam校验
        // 2.根据校验结果来进行业务处理
        // 3.如业务需要重新进行验证码验证，调用验证码初始化方法initAliyunCaptcha重新初始化验证码
        //console.error(captchaVerifyParam);
        //_this.captchaVerifyParam = captchaVerifyParam;
        if (_this.loginIndex == 0) {
          _this.loginByPwd(captchaVerifyParam);
        } else {
          _this.login(captchaVerifyParam);
        }
      },
      // 验证码验证不通过回调函数
      fail: function (result) {
        // 入参为不通过信息
        // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
        console.error(result);
      },
      onClose: function () {
        // 验证码弹窗关闭时触发的回调函数
        //console.error("close");
      },
      // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
      getInstance: function (instance) {
        _this.captcha = instance;
      },
      // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。
      slideStyle: {
        width: 360,
        height: 40,
      },
      // ...其他参数，参考initAliyunCaptcha参数说明
    });
  },
  beforeDestory() {
    clearInterval(this.loginT);
  },
  methods: {
    refreshQrcode() {
      clearInterval(this.loginT);
      let qrCodeElem = document.getElementById("qrCode");
      qrCodeElem.innerHTML = "";
      this.$axios
        .post(`${USER_HOST}/login/admin/scanQrCode`, {
          type: 5,
        })
        .then((res) => {
          if (res.data.code == 0) {
            let qrCode = new QRCode(this.$refs.qrCodeDiv, {
              text: res.data.data,
              with: 180,
              height: 180,
            });
            qrCode._el.title = "";

            localStorage.removeItem("token");

            this.loginT = setInterval(() => {
              this.getScanLogin(res.data.data);
            }, 2000);
          } else {
            this.$singleMessage.error(res.data.msg);
          }
        });
    },
    getScanLogin(key) {
      this.$axios
        .post(`${USER_HOST}/login/admin/scanLogin`, {
          key: key,
        })
        .then((res) => {
          if (res.data.code == 0) {
            clearInterval(this.loginT);

            setToken(res.data.data.token);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("u_cert_status", res.data.data.u_cert_status);
            localStorage.setItem("u_cert", res.data.data.u_cert);

            this.$message({
              type: "success",
              message: "登录成功!",
            });

            clearInterval(this.loginT);

            this.getBan();
          } else {
            //this.$singleMessage.error(res.data.msg);
          }
        });
    },
    codeOpen(index) {
      this.loginIndex = index;
      if (this.loginIndex == 0) {
        if (!this.userAccount) {
          this.$message({
            message: "账号不能为空",
            type: "warning",
          });
        } else if (!this.userPwd) {
          this.$message({
            message: "密码不能为空",
            type: "warning",
          });
        } else if (!this.loginChecked) {
          this.$message({
            message: "请阅读并同意《用户协议》与《隐私政策》",
            type: "warning",
          });
        } else {
          this.loginByPwd();
        }
      } else {
        if (this.regCodeTime != 60) {
          this.$message({
            message: "请稍后再获取",
            type: "warning",
          });
        } else if (!this.rightTel) {
          this.$message({
            message: "请输入正确的手机号码",
            type: "warning",
          });
        } else {
          this.getRegCode();
        }
      }
    },
    getRegCode() {
      this.$axios
        .post(`${COMMON_HOST}/user/risk/sms/sendCode`, {
          u_cellphone: this.userTel,
          platform: "web",
          captchaType: "login",
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message({
              type: "success",
              message: "发送成功!",
            });

            this.regCodeText = `重新获取(${this.regCodeTime})`;
            let t = setInterval(() => {
              if (this.regCodeTime > 0) {
                this.regCodeTime--;
                this.regCodeText = `重新获取(${this.regCodeTime})`;
              } else {
                this.regCodeText = `重新获取`;
                this.regCodeTime = 60;
                clearInterval(t);
              }
            }, 1000);
          } else {
            this.$singleMessage.error(res.data.msg);
          }
        });
    },
    login(captchaVerifyParam) {
      if (!this.rightTel) {
        this.$message({
          message: "请输入正确的手机号码",
          type: "warning",
        });
      } else if (!this.telVerification) {
        this.$message({
          message: "短信验证码不能为空",
          type: "warning",
        });
      } else if (!this.loginChecked) {
        this.$message({
          message: "请阅读并同意《用户协议》和《隐私政策》",
          type: "warning",
        });
      } else {
        this.$axios
          .post(`${COMMON_HOST}/user/risk/captchaLogin`, {
            u_cellphone: this.userTel,
            captchaVerifyParam: captchaVerifyParam || "",
            captcha: this.telVerification,
            captchaType: "login",
            platform: "web",
          })
          .then((res) => {
            if (res.data.code == 0) {
              if (res.data.data.loginStatus == 1) {
                let button = document.getElementById("buttonAli");
                button.click();
                return;
              }

              setToken(res.data.data.token);
              localStorage.setItem("token", res.data.data.token);
              localStorage.setItem(
                "u_cert_status",
                res.data.data.u_cert_status
              );
              localStorage.setItem("u_cert", res.data.data.u_cert);

              this.$message({
                type: "success",
                message: "登录成功!",
              });

              clearInterval(this.loginT);

              this.getBan();
            } else if (res.data.code == 40002) {
              this.getBan(1, res.data.data.token);
            } else {
              this.$singleMessage.error(res.data.msg);
            }
          });
      }
    },
    loginByPwd(captchaVerifyParam) {
      this.$axios
        .post(`${COMMON_HOST}/user/risk/passwordLogin`, {
          u_cellphone: this.userAccount,
          password: this.userPwd,
          captchaVerifyParam: captchaVerifyParam || "",
          platform: "web",
          captchaType: "login",
        })
        .then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.loginStatus == 1) {
              let button = document.getElementById("buttonAli");
              button.click();
              return;
            }

            setToken(res.data.data.token);
            localStorage.setItem("token", res.data.data.token);
            localStorage.setItem("u_cert_status", res.data.data.u_cert_status);
            localStorage.setItem("u_cert", res.data.data.u_cert);

            this.$message({
              type: "success",
              message: "登录成功!",
            });

            clearInterval(this.loginT);

            this.getBan();
          } else if (res.data.code == 40002) {
            this.getBan(1, res.data.data.token);
          } else {
            this.$singleMessage.error(res.data.msg);
          }
        });
    },
    jumpFn(url) {
      window.open(url);
    },
    getBan(isBanned, token) {
      this.$axios
        .get(
          `${SWUSER_HOST}/service/userban/getUserBanInfo?token=${
            isBanned ? token : localStorage.getItem("token")
          }`
        )
        .then((res) => {
          if (res.data.code == 0) {
            if (isBanned && res.data.data.ban_type == 2) {
              this.$refs.banShow.getReason(token);
              this.isBanned = true;
            } else {
              localStorage.setItem("banData", JSON.stringify(res.data.data));

              this.$router.push({
                path: "/index",
              });
            }
          } else {
            console.log(res.data.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-tabs__item.is-active {
  color: #409eff !important;
}

/deep/.el-tabs__item:hover {
  color: #409eff !important;
}

.el-button--primary {
  background-color: #409eff;
  border-color: #409eff;
}

/deep/.el-input__inner:focus {
  border-color: #409eff !important;
}

.loginContainer {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 1380px;
  min-height: 620px;

  .bg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    object-fit: cover;
  }

  .starBg {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .headerContainer {
    width: 100%;
    height: 94px;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 64px;

    .topLogo {
      height: 30px;
    }

    .topBtnContainer {
      display: flex;

      .topBtn {
        line-height: 22px;
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        font-weight: 400;
        cursor: pointer;
        margin-left: 48px;
      }
    }
  }

  .footerContainer {
    width: 100%;
    height: 120px;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    position: absolute;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;

    .centerContainer {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .qrCodeContainer {
      padding: 3px;
      border-radius: 8px;
      background: rgba(255, 255, 255, 1);
      width: 90px;
      height: 90px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 24px;

      .qrCode {
        width: 100%;
        height: 100%;
      }
    }

    .qrCodeTitle {
      line-height: 28px;
      color: rgba(255, 255, 255, 1);
      font-size: 20px;
      font-weight: 500;
      font-family: "PingFang SC";
      margin-bottom: 12px;
    }

    .linkContainer {
      line-height: 17px;
      color: rgba(255, 255, 255, 0.75);
      font-size: 12px;
      font-weight: 400;
      font-family: "PingFang SC";

      .linkBtn {
        cursor: pointer;
      }
    }
  }

  .mainContainer {
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;

    #bigLogo {
      height: 331px;
      margin-right: 15%;
      margin-left: -5%;
    }

    .loginBox {
      display: flex;
      width: 335px;
      height: 358px;
      border-radius: 16px;
      background: rgba(255, 255, 255, 1);
      padding: 48px 24px;
      position: relative;
      flex-shrink: 0;

      .loginTypeIcon {
        height: 64px;
        position: absolute;
        top: 0;
        right: 0;
        cursor: pointer;
      }

      .codeLogin {
        margin: 0 auto;
      }

      /deep/.el-tabs__nav-wrap::after,
      /deep/.el-tabs__active-bar {
        height: 0;
      }

      /deep/.el-tabs__item {
        color: rgba(89, 89, 89, 1);
        font-size: 16px;
        height: 22px;
        line-height: 22px;
        padding: 0 16px;
      }

      /deep/#tab-first {
        padding-left: 24px;
      }

      /deep/.el-tabs__item.is-active {
        font-weight: bold;
        color: rgba(51, 51, 51, 1) !important;
      }

      /deep/.el-tabs__item:hover {
        color: rgba(51, 51, 51, 1) !important;
      }

      /deep/.el-tabs__header {
        margin-bottom: 24px;
      }

      /deep/.el-input__inner {
        border: 0;
        border-radius: 4px;
        background: rgba(245, 245, 245, 1);
        height: 40px;
        line-height: 40px;
      }

      .el-tab-pane {
        width: 287px;
      }

      .el-input:first-child {
        width: 287px;
        margin-bottom: 16px;
      }

      .el-input:last-child {
        margin-bottom: 0;
      }

      .inputCodeContainer {
        display: flex;
        border-radius: 4px;
        background: rgba(245, 245, 245, 1);
        height: 40px;
        align-items: center;
        justify-content: space-between;

        .regCode {
          width: 170px;
          margin-bottom: 0 !important;
        }

        .buttonContain {
          position: relative;

          .getRegCodeBtn {
            color: rgba(51, 51, 51, 1);
            font-size: 14px;
            line-height: 20px;
            margin-right: 16px;
            cursor: pointer;
          }

          .codeMask {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            cursor: pointer;
          }
        }
      }

      .loginCheckContainer {
        display: flex;
        align-items: center;
        margin-top: 48px;

        .loginCheckText {
          line-height: 17px;
          color: rgba(153, 153, 153, 1);
          font-size: 12px;
          font-weight: 400;
          font-family: "PingFang SC";
          margin-left: 5px;
          cursor: pointer;
        }

        .loginAlert {
          color: #333333;
        }
      }

      .is-checked /deep/.el-checkbox__label {
        color: rgba(153, 153, 153, 1) !important;
      }

      .loginBtnContain {
        position: relative;

        .loginBtnMask {
          width: 100%;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
      }

      .loginBtn {
        width: 287px;
        line-height: 40px;
        border-radius: 4px;
        opacity: 1;
        background: rgba(215, 0, 15, 1);
        color: rgba(255, 255, 255, 1);
        font-size: 16px;
        text-align: center;
        margin-top: 16px;
        display: block !important;
        cursor: pointer;
      }

      .centerLine {
        height: 208px;
        border-radius: 8px;
        background: rgba(245, 245, 245, 1);
        margin: 46px 32px 0 32px;
        padding: 0 0 0 1px;
      }

      .codeTitle {
        height: 22px;
        color: rgba(51, 51, 51, 1);
        font-size: 16px;
        font-weight: bold;
        font-family: "PingFang SC";
        text-align: center;
        margin-bottom: 16px;
      }

      .qrCodeBorder {
        width: 180px;
        height: 180px;
        border-radius: 4px;
      }

      /deep/#qrCode {
        width: 180px;
        height: 180px;
        margin: 0 auto;
        overflow: hidden;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .qrcodeIntro {
        line-height: 17px;
        color: rgba(51, 51, 51, 1);
        font-size: 12px;
        font-weight: 400;
        font-family: "PingFang SC";
        text-align: center;
        margin-top: 16px;
      }

      .refreshQrcode {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        margin-top: 8px;

        .refreshText {
          color: #d7000f;
          font-size: 12px;
          font-weight: 400;
          font-family: "PingFang SC";
          margin-left: 4px;
        }
      }
    }
  }
}
</style>
